document.addEventListener('DOMContentLoaded', initAddonProducts);
document.addEventListener('shopify:section:load', initAddonProducts);

function initAddonProducts() {
  const sections = document.querySelectorAll('.addon-products');

  sections.forEach((section) => {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';
    section.querySelectorAll('[data-addon-carousel-container]').forEach(initAddonCarousel);

    initAddonCartButtons(section);
  });
}

function initAddonCartButtons(section) {
  section.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-addon-add]');
    if (!btn) return;
    if (btn.classList.contains('is-loading')) return;

    const variantId = btn.dataset.variantId;
    const quantity = Number(btn.dataset.quantity || 1);
    if (!variantId) return;

    btn.classList.add('is-loading');
    btn.setAttribute('aria-disabled', 'true');

    try {
      const sectionsToRender = ['cart-drawer', 'cart-bubble'];

      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: quantity }],
          sections: sectionsToRender,
          sections_url: window.location.pathname
        })
      });

      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || 'No se pudo agregar el producto');
      }

      const sectionsMap = {
        'Cart-Drawer': { section: 'cart-drawer', selector: '.cart-drawer' },
        'cart-drawer-toggle': { section: 'cart-bubble', selector: '.thb-item-count' }
      };

      Object.keys(sectionsMap).forEach(function (id) {
        const cfg = sectionsMap[id];
        const el = document.getElementById(id);

        if (!el || !data.sections || !data.sections[cfg.section]) return;

        const parsed = new DOMParser().parseFromString(data.sections[cfg.section], 'text/html');
        const inner = parsed.querySelector(cfg.selector);
        const target = el.querySelector(cfg.selector) || el;

        if (inner && target) {
          target.innerHTML = inner.innerHTML;
        }
      });

      const drawer = document.getElementById('Cart-Drawer');
      if (drawer) {
        if (typeof drawer.notesToggle === 'function') drawer.notesToggle();
        if (typeof drawer.removeProductEvent === 'function') drawer.removeProductEvent();
        if (typeof drawer.open === 'function') {
          drawer.open();
        } else {
          document.dispatchEvent(new CustomEvent('cartrefresh', { bubbles: true }));
        }
      } else {
        document.dispatchEvent(new CustomEvent('cartrefresh', { bubbles: true }));
      }

      showAddonToast('Añadido al carro');
    } catch (err) {
      console.error('Error al agregar producto de mantención:', err);
      showAddonToast('No se pudo agregar');
    } finally {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-disabled');
    }
  });
}

function initAddonCarousel(container) {
  if (!container) return;

  const viewport = container.querySelector('[data-viewport]');
  const track = container.querySelector('[data-track]');
  const prevBtn = container.querySelector('[data-addon-prev]');
  const nextBtn = container.querySelector('[data-addon-next]');

  if (!viewport || !track) return;

  const allSlides = Array.prototype.slice.call(track.querySelectorAll('[data-slide]'));
  if (!allSlides.length) return;

  const totalCopies = Number(track.dataset.copies || 3);
  const originalCount = allSlides.length / totalCopies || allSlides.length;
  const autoSpeed = Number(container.dataset.autoSpeed || 0.35);

  let rafId = null;
  let paused = false;
  let isDragging = false;
  let dragStartX = 0;
  let dragStartScroll = 0;
  let virtualScroll = 0;
  let tweenFrame = null;

  function getStep() {
    const first = track.querySelector('[data-slide]');
    if (!first) return 212;
    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || 12);
    return first.offsetWidth + gap;
  }

  function getBlockWidth() {
    return getStep() * originalCount;
  }

  function withoutSmooth(fn) {
    const previous = viewport.style.scrollBehavior;
    viewport.style.scrollBehavior = 'auto';
    fn();
    viewport.offsetHeight;
    viewport.style.scrollBehavior = previous || '';
  }

  function jumpToMiddleIfNeeded() {
    const blockWidth = getBlockWidth();
    if (!blockWidth) return;

    if (viewport.scrollLeft < blockWidth * 0.5) {
      withoutSmooth(function () {
        viewport.scrollLeft += blockWidth;
      });
      virtualScroll = viewport.scrollLeft;
    } else if (viewport.scrollLeft > blockWidth * 1.5) {
      withoutSmooth(function () {
        viewport.scrollLeft -= blockWidth;
      });
      virtualScroll = viewport.scrollLeft;
    }
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animateTo(target, duration, callback) {
  if (tweenFrame) cancelAnimationFrame(tweenFrame);

  viewport.style.scrollSnapType = 'none';

  const start = viewport.scrollLeft;
  const change = target - start;
  let startTime = null;

  function frame(time) {
    if (!startTime) startTime = time;
    const elapsed = time - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const eased = easeOutCubic(progress);

    viewport.scrollLeft = start + change * eased;
    virtualScroll = viewport.scrollLeft;

    if (progress < 1) {
      tweenFrame = requestAnimationFrame(frame);
    } else {
      tweenFrame = null;
      jumpToMiddleIfNeeded();
      virtualScroll = viewport.scrollLeft;
      viewport.style.scrollSnapType = 'x mandatory';
      if (typeof callback === 'function') callback();
    }
  }

  tweenFrame = requestAnimationFrame(frame);
  }

  function snapToNearest() {
    if (isSnapping) return;
    isSnapping = true;

    jumpToMiddleIfNeeded();
      const step = getStep();
      const blockWidth = getBlockWidth();
      const localScroll = viewport.scrollLeft - blockWidth;
      const targetIndex = Math.round(localScroll / step);
      const target = blockWidth + targetIndex * step;

    animateTo(target, 450, function () {
      jumpToMiddleIfNeeded();
      virtualScroll = viewport.scrollLeft;
      isSnapping = false;
      });
  }

  function moveOne(direction) {
    jumpToMiddleIfNeeded();

    const step = getStep();
    const current = viewport.scrollLeft;
    const target = direction === 'next' ? current + step : current - step;

    animateTo(target, 520, function () {
      jumpToMiddleIfNeeded();
      virtualScroll = viewport.scrollLeft;
    });
  }

  function stopAuto() {
    paused = true;
    if (rafId) cancelAnimationFrame(rafId);
    rafId = null;

    if (tweenFrame) {
      cancelAnimationFrame(tweenFrame);
      tweenFrame = null;
    }
  }
  function initPosition() {
    const blockWidth = getBlockWidth();
    viewport.scrollLeft = blockWidth;
    virtualScroll = viewport.scrollLeft;
  }

  if (prevBtn) {
  prevBtn.addEventListener('click', function (e) {
    e.preventDefault();
    moveOne('prev');
  });
  }
  if (nextBtn) {
  nextBtn.addEventListener('click', function (e) {
    e.preventDefault();
    moveOne('next');
  });
  }

  viewport.addEventListener('scroll', function () {
    jumpToMiddleIfNeeded();
    virtualScroll = viewport.scrollLeft;
  }, { passive: true });
  let scrollEndTimer = null;

  function onScrollEndPolyfill(callback) {
    if ('onscrollend' in window) {
      viewport.addEventListener('scrollend', callback);
    } else {
      viewport.addEventListener('scroll', function () {
      clearTimeout(scrollEndTimer);
      scrollEndTimer = setTimeout(callback, 120);
    }, { passive: true });
    }
  }
  viewport.addEventListener('touchstart', function () {
    isDragging = true;
    stopAuto();
    viewport.style.scrollSnapType = 'none';
  }, { passive: true });

  viewport.addEventListener('touchend', function () {
  isDragging = false;
  }, { passive: true });

  onScrollEndPolyfill(function () {
    if (isDragging || tweenFrame || isSnapping) return;
    snapToNearest();
  });

  viewport.addEventListener('mousedown', function (e) {
    if (e.target.closest('.addon-products__button, .maintenance-bundle__btn, a, button')) return;

    isDragging = true;
    stopAuto();
    viewport.classList.add('is-dragging');
    dragStartX = e.pageX;
    dragStartScroll = viewport.scrollLeft;
  });

  window.addEventListener('mousemove', function (e) {
    if (!isDragging) return;
    const walk = e.pageX - dragStartX;
    viewport.scrollLeft = dragStartScroll - walk;
    virtualScroll = viewport.scrollLeft;
  });

  window.addEventListener('mouseup', function () {
    if (!isDragging) return;

    isDragging = false;
    viewport.classList.remove('is-dragging');
    snapToNearest();
  });

  window.addEventListener('resize', function () {
    initPosition();
  });

  initPosition();
}

function showAddonToast(message) {
  let toast = document.querySelector('[data-addon-toast]');

  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'addon-products__toast';
    toast.setAttribute('data-addon-toast', '');
    toast.setAttribute('aria-live', 'polite');
    document.body.appendChild(toast);
  }

  toast.textContent = message || 'Añadido al carro';
  toast.classList.add('is-visible');

  clearTimeout(window.addonToastTimer);
  window.addonToastTimer = setTimeout(() => {
    toast.classList.remove('is-visible');
  }, 1800);
}